import React, { useState, ChangeEvent } from 'react';
import {
    useTheme,
    useMediaQuery,
} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from 'src/components/Buttons/Button';
import ModalWrapper from 'src/components/Modal';
import ChevronLeftIcon from 'src/assets/icons/chevron-left.svg';
import { useStyles } from './Login.styles';
import { equals, length, not } from 'ramda';

interface Props {
    selectMFA: boolean;
    toggleMFAModal: () => void;
    mobileEndingWith: Object;
    handleOTPSubmit: any;

}
const OTPVerification = ({ selectMFA, toggleMFAModal, mobileEndingWith, handleOTPSubmit }: Props) => {
    const [verificationCode, setVerificationCode] = useState<any>(null);
    const classes = useStyles();
    const { breakpoints } = useTheme();
    const matchesSm = useMediaQuery(breakpoints.down('sm'));
    const matchesMd = useMediaQuery(breakpoints.down('md'));

    const handleVerificationCodeChange = (e: ChangeEvent<HTMLInputElement>) =>
        setVerificationCode(e.target.value);

    const handleToggleMFAModal = () => {
        setVerificationCode(null);
        toggleMFAModal();
    };

    return (
        <ModalWrapper
            hideCloseIcon
            hideActionButtons
            showModal={selectMFA}
            toggleModal={handleToggleMFAModal}
            width={700}
        >
            <Box className={classes.modal}>
                <Button
                    px={5}
                    py={6}
                    text="Go back"
                    variant="text"
                    onClick={handleToggleMFAModal}
                    startIcon={<ChevronLeftIcon width="13px" height="13px" />}
                    className={classes.goBackBtn}
                    styles={{ fontSize: 14, fontFamily: 'Open Sans' }}
                />
                <Typography
                    variant="h1"
                    align="center"
                    fontSize={24}
                    textAlign="center"
                    mt={matchesSm ? 2 : 0}
                >
                    Two-factor Authentication
                </Typography>

                <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
                    <Typography
                        variant="body1"
                        color="basic.grey"
                        whiteSpace='initial'
                        textAlign="center"
                    >
                        We've sent a verification code to your email and/or mobile number (if available). {"\n"} Please check your inbox and/or mobile.
                    </Typography>
                    <Box width={matchesMd ? '100%' : 404} my={4}>
                        <Typography
                            color="basic.darkGrey"
                            lineHeight="16px"
                            fontSize={12}
                            mb={0.5}
                        >
                            Verification Code
                        </Typography>
                        <TextField
                            placeholder="Verification Code"
                            value={verificationCode}
                            onChange={handleVerificationCodeChange}
                            type='number'
                            sx={{
                                marginBottom: 4
                            }}
                        />
                    </Box>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        text="Cancel"
                        onClick={handleToggleMFAModal}
                        variant="outlined"
                        px={45}
                    />
                    <Button
                        text="Log In"
                        px={45}
                        styles={{ marginLeft: '20px' }}
                        disabled={not(equals(length(verificationCode), 6))}
                        onClick={() => handleOTPSubmit(verificationCode)}
                    />
                </Box>
            </Box>
        </ModalWrapper>
    );
}

export default OTPVerification;
